<script setup>
  import { computed } from 'vue';

  let props = defineProps(['data', 'modelValue', 'style', 'assetSortReverse']);
  let emit = defineEmits(['update:modelValue']);

  let imageList = computed(() => {
    let images = [], keys = Object.keys(props.data);

    if (props.assetSortReverse) {
      keys = keys.reverse();
    }

    keys.forEach(key => {
      if (props.data[key] && props.data[key].type === 'image') {
        images.push({ id: key, image: props.data[key] });
      }
    });

    return images;
  });

  function updateValue (value, e) {
    emit('update:modelValue', value, e.target.value);
  }

</script>

<template>
  <div class="image-select" :style="style">
    <div :class="{
      'image-option': true,
      'no-value': true,
      'selected': !modelValue,
    }" title="No Image" aria-label="No Image" :aria-selected="!modelValue ? 'true' : 'false'" @click="e => updateValue('', e)">No Image</div>
    <div v-for="({image, id}) in imageList" :key="id" :class="{
      'image-option': true,
      'image-value': true,
      'selected': modelValue == id,
    }" :style="{
      'background-image': 'url(' + image.thumbnail + ') ',
    }" :title="image.name" :aria-label="image.name" :aria-selected="modelValue == id ? 'true' : 'false'" @click="e => updateValue(id, e)"></div>
  </div>
</template>

<style scoped>
  .image-select {
    overflow: auto;
    white-space: normal;
  }

  .image-option {
    display: inline-block;
    width: 100px;
    height: 100px;
    margin: 0.5em 0.25em;
    background: #757575 center/contain no-repeat;
    text-align: center;
    vertical-align: top;
  }

  .image-option.no-value {
    color: #000;
    padding: 1em 0;
    font-weight: 700;
  }

  .image-option.selected {
    outline: 1px dotted #000;
  }
</style>
